/** Node types that can be the source of a flow (money leaves them). */
const VALID_SOURCES = new Set(["income", "account", "oneoff"]);
/** Where a one-off may direct its amount. */
const ONEOFF_TARGETS = new Set(["account", "card", "pot"]);
/** Whether a flow may connect a source node type to a target node type. */
export function canConnect(source, target) {
    // Note: account-to-account (a transfer or ring-fence) is allowed; a node
    // connecting to itself is caught elsewhere by an id check.
    if (!VALID_SOURCES.has(source)) {
        return { ok: false, reason: "Only income, accounts and one-offs can send money." };
    }
    if (target === "income") {
        return { ok: false, reason: "Income cannot receive money." };
    }
    if (source === "income" && target !== "account") {
        return { ok: false, reason: "Income must flow into an account first." };
    }
    // A one-off can be directed at an account, card or pot (e.g. an overpayment).
    if (source === "oneoff" && !ONEOFF_TARGETS.has(target)) {
        return { ok: false, reason: "A one-off can feed an account, card or pot." };
    }
    return { ok: true };
}
//# sourceMappingURL=connection.js.map